import React from 'react';
import block from 'bem-cn-lite';
import {Field} from 'react-final-form';

import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';
import CalculatorFormLayout from 'components/calculator/CalculatorFormLayout/CalculatorFormLayout';
import {FormFieldNumberInput} from 'components/formFields';

import './TrafficField.scss';

const b = block('TrafficField');

export interface TrafficFieldProps extends WithTranslationProps {
    name?: string;
}

const TrafficField: React.FC<TrafficFieldProps> = ({name = 'traffic', i18n, i18nK}) => (
    <CalculatorFormLayout.Row
        className={b()}
        title={i18nK('field_traffic')}
        note={i18nK('context_traffic')}
    >
        <Field name={name}>
            {(fieldProps) => (
                <FormFieldNumberInput
                    {...fieldProps}
                    withoutControls={true}
                    defaultValue={0}
                    maxLength={12}
                />
            )}
        </Field>
        <div className={b('label')}>{i18n('common', 'label_unit-gigabyte')}</div>
    </CalculatorFormLayout.Row>
);

export default withTranslation('calculator')(TrafficField);
